.container {
  display: flex;
  align-items: center;
  padding-top: 10px;
}

.icon {
  display: flex;
  border-width: 1px;
  border-style: solid;
  border-color: var(--button-border);
  cursor: pointer;
}

.icon:hover {
  border-color: var(--hover-dark);
  background-color: var(--hover-dark);
}

.icon svg {
  width: 1.4rem;
  fill: currentcolor;
}

.pages {
  white-space: nowrap;
  padding: 0 5px;
}
